import { IErrorCodeInfo } from '@notes/webintegrations-common'

export namespace Errors {
  export const shellApiError: IErrorCodeInfo = {
    name: 'ShellApiError',
    errorCode1: 0xDC000007,
    errorCode2: 0xDC000007,
    errorTag: 'ShellApiError',
  }

  export function getLocalizationActivityError(errorTag: string): IErrorCodeInfo {
    return {
      name: 'LocalizationError',
      errorCode1: 0xDC000008,
      errorCode2: 0xDC000008,
      errorTag: errorTag,
    }
  }

  export const shellLoadingError: IErrorCodeInfo = {
    name: 'ShellLoadingError',
    errorCode1: 0xDC000009,
    errorCode2: 0xDC000009,
    errorTag: 'ShellLoadingError',
  }

  export function getSetTokenInSdkError(errorTag: string): IErrorCodeInfo {
    return {
      name: 'SetTokenInSdkError',
      errorCode1: 0xDC000010,
      errorCode2: 0xDC000010,
      errorTag: errorTag,
    }
  }

  export function getRefreshTokenForSdkError(errorTag: string): IErrorCodeInfo {
    return {
      name: 'RefreshTokenForSdkError',
      errorCode1: 0xDC000011,
      errorCode2: 0xDC000011,
      errorTag: errorTag,
    }
  }

  export function getInitialTokenFetchError(errorTag: string): IErrorCodeInfo {
    return {
      name: 'InitialTokenFetchError',
      errorCode1: 0xDC000012,
      errorCode2: 0xDC000012,
      errorTag: errorTag,
    }
  }
}
